import type { ReactNode } from 'react';
import { useNavigate } from 'react-router';
import { MdLogout, MdDirectionsBike } from 'react-icons/md';
import { useAuth } from '@/contexts/AuthContext';

export default function PortalLayout({ children }: Readonly<{ children: ReactNode }>) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-brand-700 text-white shadow-md">
        <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <MdDirectionsBike className="text-2xl" />
            <span className="text-xl font-bold">RandoBR</span>
            <span className="text-brand-200 text-sm ml-1">Portal do Randonneur</span>
          </div>
          <div className="flex items-center gap-4">
            {user?.name && (
              <span className="text-sm text-brand-100 hidden sm:block">{user.name}</span>
            )}
            <button
              onClick={handleLogout}
              className="flex items-center gap-1 text-sm text-brand-100 hover:text-white transition-colors"
            >
              <MdLogout className="text-lg" />
              <span>Sair</span>
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-8">
        {children}
      </main>
    </div>
  );
}
